import "./src/styles/global.css";
import "./src/styles/fonts.css";

export const onClientEntry = () => {
  window.onloadCallback = () => undefined;

  // Ustaw domyślny stan zgód zanim GTM cokolwiek wyśle
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }

  gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "denied",
    personalization_storage: "denied",
    security_storage: "granted",
    wait_for_update: 500,
  });

  window.addEventListener("CookiebotOnAccept", () => {
    gtag("consent", "update", {
      ad_storage: window.Cookiebot?.consent?.marketing ? "granted" : "denied",
      ad_user_data: window.Cookiebot?.consent?.marketing ? "granted" : "denied",
      ad_personalization: window.Cookiebot?.consent?.marketing ? "granted" : "denied",
      analytics_storage: window.Cookiebot?.consent?.statistics ? "granted" : "denied",
      functionality_storage: window.Cookiebot?.consent?.preferences ? "granted" : "denied",
      personalization_storage: window.Cookiebot?.consent?.preferences ? "granted" : "denied",
    });
  });

  window.addEventListener("CookiebotOnDecline", () => {
    gtag("consent", "update", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
      functionality_storage: "denied",
      personalization_storage: "denied",
    });
  });
};